import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { BrandLogo } from "@/components/BrandLogo";

export function SiteFooter() {
  const { t } = useLanguage();
  return (
    <footer id="contact" className="bg-sidebar text-sidebar-foreground">
      <div className="mx-auto max-w-6xl px-4 py-14">
        <div className="flex flex-col justify-between gap-10 md:flex-row">
          <div className="max-w-sm">
            <BrandLogo invert />
            <p className="mt-4 text-sm leading-relaxed text-sidebar-foreground/70">{t("footer.tagline")}</p>
          </div>
          <div className="grid grid-cols-2 gap-10 text-sm">
            <div className="flex flex-col gap-2.5">
              <span className="font-medium text-sidebar-foreground">{t("nav.services")}</span>
              <a href="#services" className="text-sidebar-foreground/70 hover:text-sidebar-foreground">{t("services.1.title")}</a>
              <a href="#services" className="text-sidebar-foreground/70 hover:text-sidebar-foreground">{t("services.2.title")}</a>
              <a href="#security" className="text-sidebar-foreground/70 hover:text-sidebar-foreground">{t("nav.security")}</a>
            </div>
            <div className="flex flex-col gap-2.5">
              <span className="font-medium text-sidebar-foreground">Aureus Notariat</span>
              <span className="text-sidebar-foreground/70">Bockenheimer Landstr. 24</span>
              <span className="text-sidebar-foreground/70">60323 Frankfurt am Main</span>
              <span className="text-sidebar-foreground/70">mandate@aureus-notariat.de</span>
            </div>
          </div>
        </div>
        <div className="mt-10 border-t border-sidebar-border pt-6">
          <p className="text-xs leading-relaxed text-sidebar-foreground/60">{t("footer.disclaimer")}</p>
          <p className="mt-3 text-xs text-sidebar-foreground/50">
            &copy; {new Date().getFullYear()} Aureus Notariat. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}
